import React, { Component } from 'react';
import Lang from 'libraries/Lang';
import LoadingModal from '../../../helpers/loadingModal';

class Groups extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingModel: false,
        };

        this.submit = this.submit.bind(this);
    }

    submit(event) {
        this.setState({ loadingModel : true });
        window.location.href = '/launch/groups?page=travelgenie';

    }

    render() {
        let grpLanguage = (window.location.pathname !== 'undefined') ? window.location.pathname.replace('/', '') : '';
        if (grpLanguage !== 'fr') {
            grpLanguage = 'en';
        }
        const { loadingModel } = this.state 
        return (
            <>
            <LoadingModal isLoading={loadingModel} />
            <form className="search-flight">
                <input type="hidden" name="request" value="" />
                <div className="row gutter-10 mb-3 text-center">
                    <div className="col-12">
                        <h5 className="font-weight-bold text-dark mb-0">{Lang.trans('groups.book_group')}</h5>
                    </div>
                </div>

                <div className="row gutter-10 border-top mt-2">
                    <div className="col-12 text-center mt-3">
                        <a href={'/launch/groups?page=travelgenie&lang='+grpLanguage}  className="btn btn-primary btn-lg px-5 font-weight-600 mx-md-2 d-inline-flex align-items-center justify-content-center">
                            <span className="">{Lang.trans('groups.book_button')}</span>
                        </a>
                    </div>
                </div>
            </form>
            </>
        );
    }
}

export default Groups;
